export const BellIcon = ({
  width = '16',
  height = '16',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.06787 11.8572C4.6286 12.5522 5.50948 13 6.50001 13C7.49054 13 8.37141 12.5522 8.93214 11.8572C7.31761 12.0705 5.68241 12.0705 4.06787 11.8572Z"
        fill="currentColor"
      />
      <path
        d="M10.9994 4.55V5.00767C10.9994 5.55692 11.1602 6.09388 11.4615 6.55083L12.1997 7.67078C12.8741 8.69369 12.3593 10.084 11.1864 10.4075C8.1182 11.2537 4.88183 11.2537 1.81357 10.4075C0.6407 10.084 0.125881 8.69369 0.80024 7.67078L1.53853 6.55083C1.83981 6.09388 2.00058 5.55692 2.00058 5.00767V4.55C2.00058 2.03711 4.01504 0 6.5 0C8.98493 0 10.9994 2.03711 10.9994 4.55Z"
        fill="currentColor"
      />
    </svg>
  );
};
